import type { CourseModule } from "@/core/types";
import { lektionUeberschriftenNummerieren } from "./lektion-01-nummerieren";
import { lektionKapitelnummerierungAbschluss } from "./lektion-02-abschluss";

export const modulKapitelnummerierung: CourseModule = {
  id: "kapitelnummerierung",
  title: "Kapitelnummerierung",
  summary:
    "Überschriften automatisch nummerieren lassen – 1., 1.1, 1.1.1 ohne eine " +
    "einzige getippte Zahl.",
  level: "Aufbau",
  lessons: [lektionUeberschriftenNummerieren, lektionKapitelnummerierungAbschluss],
};
